import { Link } from "react-router-dom";
import { Info, ArrowUpRight } from "lucide-react";

export default function DemoRibbon() {
  return (
    <div
      data-testid="demo-ribbon"
      className="relative w-full bg-navy text-white"
    >
      <div className="absolute inset-x-0 bottom-0 h-px bg-sun-stripe" />
      <div className="container-page flex items-center justify-between gap-3 py-2 text-xs">
        <div className="flex items-center gap-2 truncate">
          <Info className="h-3.5 w-3.5 text-aqua" aria-hidden="true" />
          <span className="truncate">
            <span className="font-medium text-white">Demo site</span>
            <span className="mx-1.5 text-white/45">·</span>
            <span className="text-white/75">
              built by <span className="text-aqua">PrismForge Digital</span> as
              a portfolio piece
            </span>
          </span>
        </div>
        <Link
          to="/demo"
          data-testid="demo-ribbon-link"
          className="group inline-flex shrink-0 items-center gap-1 rounded-full border border-white/15 px-2.5 py-0.5 font-medium text-white/90 transition-colors hover:border-aqua/60 hover:text-aqua"
        >
          What is this?
          <ArrowUpRight className="h-3 w-3 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </Link>
      </div>
    </div>
  );
}
